import React from 'react';
import GxList from '../../gx/GxList';
import { useTranslation } from '../../hx/useTranslation';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { useNav } from '../../hx/useNav';
import { useWindowSize } from '../../hx/useWindowSize';
import { clearStore, StoreClient, isApp } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import GxIconButtonLastClient from '../../gx/GxIconButtonLastClient';
import * as FxDat from '../../fx/FxDat';


const MxImageList = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();
  const size = useWindowSize();

  const [storeClient, setStoreClient] = useSessionStorage('StoreClient', StoreClient);

  const r_list = React.useRef(null);

  const hasColumnBranchId = () => { return Boolean(localStorage.getItem('MxImageList.addcol_txBranchId') === '1') };

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  React.useEffect(() => {
    clearStore('StoreClient', storeClient);
    // eslint-disable-next-line
  }, []);

  const openForm = async (op, row) => {
    if (row === null) {
      storeClient.inClient = null;
      storeClient.txClient = null;
      storeClient.inAnimal = null;
      storeClient.txAnimal = null;
      storeClient.inImage = null;
    } else {
      FxLog.infox('MxImageList.row.original', '...row.original:', row.original);
      storeClient.inClient = row.original.inClient;
      storeClient.txClient = row.original.txClient;
      storeClient.inAnimal = row.original.inAnimal;
      storeClient.txAnimal = row.original.txAnimal;
      storeClient.inImage = row.original.inImage;
    }
    setStoreClient(storeClient);

    navTo("image-form");
  }

  const getTableColumns = () => {
    let cols = [];
    try{
      let id = -1;
      cols.push({ id: id++, Header: "ID", accessor: "inImage", show: false });
      if (size.isLarge) { // PANTALLA GRANDE
        cols.push({ id: "txBranchId", Header: trans('field.branch_id'), accessor: "txBranchId", highlight: true, width: '5%', show: hasColumnBranchId() });
        cols.push({ id: id++, Header: trans('field.date'), accessor: "dtFrom", highlightDate: true, width: '10%' });
        cols.push({ id: id++, Header: trans('field.type'), accessor: "txTypeImage", highlight: true, width: '10%' });
        cols.push({ id: id++, Header: trans('field.client'), accessor: "txClient", highlight: true, width: '20%' });
        if (isApp('vett') || isApp('spaw')) {
          cols.push({ id: id++, Header: trans('field.patient'), accessor: "txAnimal", highlight: true, width: '10%' });
        }
        cols.push({ id: id++, Header: trans('field.remarks'), accessor: "txRemarks", highlight: true, width: '50%' });
        
      } else { // PANTALLA PEQUEÑA
        cols.push({ id: id++, Header: trans('field.date'), accessor: "dtFrom", highlightDate: true, width: '20%' });
        cols.push({ id: id++, Header: trans('field.client'), accessor: "txClient", highlight: true, width: '40%' });
        cols.push({ id: id++, Header: trans('field.remarks'), accessor: "txRemarks", highlight: true, width: '40%' });
      }

      cols.push({ id: "A", Header: "inactive", accessor: row => FxDat.isExpired(row["client_dtTo"]), show: false });
      cols.push({ id: "R", Header: "debtor", accessor: row => Boolean(Number(row["client_theBalance"]) < 0), show: false });

    } catch(error) {
      FxLog.errorx('MxImageList.getTableColumns', error)
    }
    return cols;
  }

  const getTableOptionalCols = () => {
    let cols = [];
    cols.push({ id: 'txBranchId', name: trans('field.branch_id') + " +🔍︎", checked: hasColumnBranchId() ? '1' : '0' });
    return cols;
  }

  const optionsSelected = (options) => {
    localStorage.setItem('MxImageList.addcol_txBranchId', options.includes('txBranchId') ? '1' : '0');
    r_list.current.getTable().setTooltipText(getTooltip());
    r_list.current.getTable().clearSearch();
    forceUIUpdate();
  }

  const getTooltip = () => {
    let tip = '';
    if (size.isLarge) { // PANTALLA GRANDE
      tip = `${trans('field.date')}`;
      tip = tip + `${' / ' + trans('field.type')}`;
      if (hasColumnBranchId()) tip = tip + `${' / ' + trans('field.branch_id')}`;
      tip = tip + `${' / ' + trans('field.client')}`;
      if (isApp('vett') || isApp('spaw')) {
        tip = tip + `${' / ' + trans('field.patient')}`;
      }
      tip = tip + `${' / ' + trans('field.remarks')}`;
      
    } else { // PANTALLA PEQUEÑA
      tip = `${trans('field.date')}`;
      tip = tip + `${' / ' + trans('field.client')}`;
      tip = tip + `${' / ' + trans('field.remarks')}`;
    }

    return tip;
  }

  return (
    <div>
      <GxList
        moduleName={`${trans('field.images')}`}
        xref={r_list}
        tooltip={getTooltip()}
        fullscreen
        showtip
        url="images"
        //filter={`n_multimedia.txLinkMultimediaTable='n_branch'`}
        onOpenForm={openForm}
        columns={getTableColumns()}
        refColors={[
          `table_cell_color_red|${trans('field.debtor')}`,
          `table_cell_color_gray|${trans('field.inactive')}`,
        ]}
        optionalColumns={getTableOptionalCols()}
        onOptions={optionsSelected}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <GxIconButtonLastClient theList={r_list} />
          </div>
        }
      />

    </div>
  );

}

export default MxImageList;